// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.material-table .el-table__empty-block {\n  width: 100% !important;\n  min-width: 100%;\n  position: sticky;\n  left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
